<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">Move files</div>

    <div class="modal-body cl-form">
      <p class="mb-3">You are about to move the following files</p>
      <div class="files-table-scroll">
        <table class="cl-table-data cl-table-data-light">
          <thead>
            <tr>
              <th class="cl-table-head">
                Type
              </th>
              <th class="cl-table-head">
                File or folder name
              </th>
              <th class="cl-table-head">
                <div>
                  Last Modified
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (file of (files$ | async); track file) {
              <tr>
                <td>
                  @if (file.__typename === 'File') {
                    <i class="fas fa-file"></i>
                  }
                  @if (file.__typename === 'Folder') {
                    <i class="fas fa-folder"></i>
                  }
                </td>
                <td>
                  {{ file.name }}
                </td>
                <td class="cl-td-time">
                  <app-date [value]="file?.last_modified" />
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

        <label for="src_folder" class="form-label mt-3">From</label>
        <textarea id="src_folder" class="form-control no-wrap" rows="2" wrap="off" readonly>{{ src_basefolder }}</textarea>
        <label for="dest_prefix" class="form-label mt-3">To</label>
        <div class="dest-prefix-row">
          <input id="dest_prefix" type="text" class="form-control no-wrap" [(ngModel)]="dst_folder"/>
          <button type="button" class="btn cl-color-secondary" aria-label="Browse for destination folder"
            appTooltip="Browse for destination folder" (click)="browse()">
            <i class="fas fa-folder-open" aria-hidden="true"></i>
          </button>
        </div>

        <p class="alert cl-alert-info" role="alert"> This dialog will close automatically once the move is complete, but
        you can close it manually without interrupting the process.</p>
      </div>
      <div class="modal-footer">
        <app-form-footer label="Move files" (action)="move($event)">
          <button footerStart type="button" class="btn cl-color-secondary it-cancel" (click)="close()"><span>Cancel</span></button>
        </app-form-footer>
      </div>

      </div>
    </div>

